import {createStore, combineReducers} from 'redux';
import authReducer from './reducers/auth';
import companyReducer from './reducers/company';


const rootReducer = combineReducers({
    auth: authReducer,
    company: companyReducer
   
});

const store = createStore(rootReducer);

export default store;
